import { IconButton, ButtonProps, Tooltip, GridItem } from "@chakra-ui/react";
import { OperationBase } from "@syla/shared/types/requests/BulkEditRequest";
import React from "react";
import { FiTrash2 } from "react-icons/fi";

export function DeleteButtonGridItem<T extends OperationBase>({
  operation,
  operations,
  setOperations,
  ...buttonProps
}: {
  operation: T;
  operations: T[];
  setOperations: React.Dispatch<React.SetStateAction<T[]>>;
} & ButtonProps) {
  return (
    <GridItem>
      <Tooltip label="Delete">
        <IconButton
          colorScheme="red"
          variant="ghost"
          aria-label="Delete"
          icon={<FiTrash2 />}
          isDisabled={operations.length < 2}
          onClick={() => {
            setOperations((operations) =>
              operations.filter((op) => op.id !== operation.id),
            );
          }}
          {...buttonProps}
        />
      </Tooltip>
    </GridItem>
  );
}
